import { constants } from '@eti/utils';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { getTravelersPrimaryFlow, bundleBaggageDetails, getPreselected } from './checkInBaggageUtils';
import { hasMultipleNonInfantTravelers } from '../../common/utils/baggageUtils';
export const useCheckedBag = ({
  travelerNumber,
  order,
  bundleData,
  includedBaggage
}) => {
  var _order$sellSpecificat, _order$sellSpecificat2;
  const travelers = getTravelersPrimaryFlow(order);
  const traveler = (travelers === null || travelers === void 0 ? void 0 : travelers[travelerNumber]) || {};
  const isInfant = traveler.ageType === constants.ageTypes.INFANT;
  const isFirstTraveler = travelerNumber === 0;
  const {
    options = [],
    hasMultipleWeightOptions = false
  } = (_order$sellSpecificat = (_order$sellSpecificat2 = order.sellSpecification) === null || _order$sellSpecificat2 === void 0 ? void 0 : _order$sellSpecificat2.sellPriceBaggage[0]) !== null && _order$sellSpecificat !== void 0 ? _order$sellSpecificat : {};
  const includedCheckedBaggageInTrip = includedBaggage || bundleBaggageDetails(bundleData);
  const isCheckedBaggageIncludedInTrip = includedCheckedBaggageInTrip && Object.keys(includedCheckedBaggageInTrip).length !== 0;
  const isCheckedBagPreselected = getPreselected(travelers);
  return {
    checkedBagOptions: options,
    hasMultipleWeightOptions,
    isInfant,
    isFirstTraveler,
    isCheckedBaggageIncludedInTrip,
    traveler,
    hasMultipleNonInfantTravelers: hasMultipleNonInfantTravelers(travelers),
    isCheckedBagPreselected
  };
};
//# sourceMappingURL=useCheckedBag.js.map